module.exports = __webpack_public_path__ + "img/strikethrough-square.801a8b06.svg";